import { css } from 'styled-components';
import { FeatureProps } from '../../../../components/Feature/Feature';
import {
  FeatureGrid,
  ImageGridItem,
  TextGridItem,
} from '../../../../components/Feature/FeatureContainer/styles';
import {
  Heading,
  Subheading,
} from '../../../../components/Feature/FeatureContents/styles';
import { gridItemPropsOverride } from '../../../../components/Grid/GridItem/styles';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';

export default css<FeatureProps>`
  ${TextGridItem} {
    ${({ image }) =>
      gridItemPropsOverride({
        desktop: image ? 6 : 8,
        tabletLandscape: image ? 6 : 8,
        tabletPortrait: 8,
        mobile: 4,
      })}
  }

  ${ImageGridItem} {
    ${gridItemPropsOverride({
      desktop: 6,
      tabletLandscape: 6,
      tabletPortrait: 8,
      mobile: 4,
    })}
  }

  ${Heading} {
    margin-top: ${spacing(3)};

    ${mediaQuery.desktop`
        margin-top: 0;
      `}
  }

  ${Subheading} {
    margin-top: ${spacing(2)};
    margin-bottom: ${spacing(3)};
  }

  &${FeatureGrid} {
    align-items: center;
  }
`;
